import ImageEditorPanel from './imageEditorPanel.container'

export default ImageEditorPanel